/**
 * Types
 */
export enum Types {
  //SET CURRENT TAB
  SET_CURRENT_TAB = "profile/SET_CURRENT_TAB",
  // GET PERFIL
  REQUEST_PROFILE_LOAD = "profile/REQUEST_PROFILE_LOAD",
  SUCCESS_PROFILE_LOAD = "profile/SUCCESS_PROFILE_LOAD",
  FAILURE_PROFILE_LOAD = "profile/FAILURE_PROFILE_LOAD",


  // GET
  REQUEST_PROFILE_METAS_LOAD = "profile/REQUEST_PROFILE_METAS_LOAD",
  SUCCESS_PROFILE_METAS_LOAD = "profile/SUCCESS_PROFILE_METAS_LOAD",
  FAILURE_PROFILE_METAS_LOAD = "profile/FAILURE_PROFILE_METAS_LOAD",
  // PUT - FLAG ACEITE
  REQUEST_ACCEPT_META = "profile/REQUEST_ACCEPT_META",
  SUCCESS_ACCEPT_METAS = "profile/SUCCESS_ACCEPT_METAS",
  FAILURE_ACCEPT_METAS = "profile/FAILURE_ACCEPT_METAS",
  // GET ALL - PROJETO
  REQUEST_GET_PROJECTS = "profile/REQUEST_GET_PROJECTS",
  SUCCESS_GET_PROJECTS = "profile/SUCCESS_GET_PROJECTS",
  FAILURE_GET_PROJECTS = "profile/FAILURE_GET_PROJECTS",
  // GET BY ID - PROJETO
  REQUEST_GET_PROJECT_BY_ID = "profile/REQUEST_GET_PROJECT_BY_ID",
  SUCCESS_GET_PROJECT_BY_ID = "profile/SUCCESS_GET_PROJECT_BY_ID",
  FAILURE_GET_PROJECT_BY_ID = "profile/FAILURE_GET_PROJECT_BY_ID",
  // POST - PROJETO
  REQUEST_ADD_PROJECT = "profile/REQUEST_ADD_PROJECT",
  SUCCESS_ADD_PROJECT = "profile/SUCCESS_ADD_PROJECT",
  FAILURE_ADD_PROJECT = "profile/FAILURE_ADD_PROJECT",
  // PUT - PROJETO
  REQUEST_EDIT_PROJECT = "profile/REQUEST_EDIT_PROJECT",
  SUCCESS_EDIT_PROJECT = "profile/SUCCESS_EDIT_PROJECT",
  FAILURE_EDIT_PROJECT = "profile/FAILURE_EDIT_PROJECT",
  // DELETE - PROJETO
  REQUEST_DEL_PROJECT = "profile/REQUEST_DEL_PROJECT",
  SUCCESS_DEL_PROJECT = "profile/SUCCESS_DEL_PROJECT",
  FAILURE_DEL_PROJECT = "profile/FAILURE_DEL_PROJECT",
  // GET - SOLICITAR APROVAÇÃO
  REQUEST_APROVACAO = "profile/REQUEST_APROVACAO",
  SUCCESS_APROVACAO = "profile/SUCCESS_APROVACAO",
  FAILURE_APROVACAO = "profile/FAILURE_APROVACAO",
};


interface IHeadcountState {
  readonly currentTab: string;
  readonly data: IProfileMetasType;
  readonly dataProfile: IProfileType;
  readonly success: boolean;
  readonly loadingProject: boolean;
  readonly error: boolean;
  readonly loadingData: boolean;
  readonly hasMetas: boolean;
  readonly canRequestApproval: boolean;
  readonly sendRequestApproval: boolean;
};

export interface ITemporadaType {
  idCiclo: number;
  ano: number;
  status: string;
}

export interface IProfileType {
  idFuncionario: number | null,
  matricula: string,
  nomeCompleto: string,
  status: string,
  Cargo: {
    idCargo: number | null,
    codCargo: string,
    titulo: string
  },
  Area: {
    idArea: number | null,
    codArea: string,
    nomeLocal: string
  }
}

export interface ICicloPesoPerfil {
  idObjetivo: number;
  peso: string | number;
  objetivo: {
    descObjetivo: string;
    mecanicaCalculo: string;
    unidade: string;
  };
};

export interface IMetaPerfil {
  idCicloMeta: number;
  idCiclo: number;
  idObjetivo: number;
  minimo: number | string;
  target: number | string;
  maximo: number | string;
  habilitarReferencia: boolean;
  minimoRef: number;
  targetRef: number;
  maximoRef: number
}

interface ICicloPesoPaiTypes {
  idCicloPeso: number;
  idObjetivo: number;
  objetivo: {
    descObjetivo: string;
  }
}

export interface ICicloPesosPerfil {
  idCicloPeso: number;
  contMeta: number;
  idCicloColaboradorMeta: number;
  cicloPeso: ICicloPesoPerfil;
  meta: IMetaPerfil[];
  pilar: {
    nomePilar: string;
    corPilar: string;
  };
  cicloPesoPai: ICicloPesoPaiTypes;
}

export interface IProjectType {
  idCicloColaboradorProjeto: number | null;
  idCiclo: number | null;
  idFuncionario?: number | null;
  idCicloPesoPai: number | null;
  nomeProjeto: string;
  descProjeto: string;
  peso: string | number;
  prazoEntrega: Date | null;
}

export interface IProjectSelectedState {
  item: IProjectType;
  loading: boolean;
  success: boolean;
}

export interface IObjetivosPesosAreas {
  idCicloPeso: number | null;
  idObjetivo: number | null;
  idArea: number | null;
  objetivo: {
    descObjetivo: string;
  }
}

export interface IAllPositionsType {
  idCicloColaborador: number;
  titulo: string;
  idVaga: number;
  idArea: number;
  status: string;
}

export interface IPositionType {
  idCicloColaborador: number | null;
  vigencia: Date | null;
  idArea: number | null;
  idVaga: number | null;
  status: string;
  area: {
    nomeLocal: string;
    idAreaPai: number | null;
  };
  vaga: {
    status: string;
    idArea: number | null;
    idCargo: number | null;
    idUnidade: number | null;
    idFuncionario: number | null;
    area: {
      idAreaPai: number | null;
      nomeLocal: string;
    };
    cargo: {
      codCargo: string;
      titulo: string;
    };
  };
  metas: ICicloPesosPerfil[];
  projetos: IProjectType[];
  descPeriodo: string;
  flagSolicitarAprovacao: boolean;
}

export interface IProfileMetasType {
  temporadas: ITemporadaType[];
  posicoes: IAllPositionsType[];
  posicao: IPositionType;
  objetivosPesoAreas: IObjetivosPesosAreas[];
  FuncionarioOwner: {
    idFuncionario: number | null;
    matricula: string;
    nomeCompleto: string;
    status: string;
  }
  projectSelected: IProjectSelectedState;
}

export type DataTypes = IHeadcountState;


/**
 * Actions
 */

//GET PROFILE
export interface IRequestLoadProfileAction {
  type: typeof Types.REQUEST_PROFILE_LOAD;
  id?: number;
};

export interface ISuccessLoadProfileAction {
  type: typeof Types.SUCCESS_PROFILE_LOAD;
  payload: IProfileType;
};

export interface IFailureLoadProfileAction {
  type: typeof Types.FAILURE_PROFILE_LOAD;
  message: string;
};

type ProfileLoadAction = IRequestLoadProfileAction | ISuccessLoadProfileAction | IFailureLoadProfileAction;

//GET
export interface ISetCurrentTabAction {
  type: typeof Types.SET_CURRENT_TAB;
  indexTab: string;
};


export interface IRequestProfileMetasAction {
  type: typeof Types.REQUEST_PROFILE_METAS_LOAD;
  payload: {
    idFuncionario?: number | null,
    idCiclo?: number,
    idCicloColaborador?: number
  }
};

export interface ISuccessProfileMetasAction {
  type: typeof Types.SUCCESS_PROFILE_METAS_LOAD;
  payload: IProfileMetasType;
};

export interface IFailureProfileMetasAction {
  type: typeof Types.FAILURE_PROFILE_METAS_LOAD;
  message: string;
};

type GetProfileMetasAction = IRequestProfileMetasAction | ISuccessProfileMetasAction | IFailureProfileMetasAction;

//PUT - ACCEPT META
export interface IRequestAcceptMetaAction {
  type: typeof Types.REQUEST_ACCEPT_META;
  payload: {
    idCicloMetaColaborador: number;
    flagAceite: boolean;
  };
};

export interface ISuccessAcceptMetaAction {
  type: typeof Types.SUCCESS_ACCEPT_METAS;
  payload: {
    idCicloMetaColaborador: number;
    flagAceite: boolean;
  };
};

export interface IFailureAcceptMetaAction {
  type: typeof Types.FAILURE_ACCEPT_METAS;
  message: string;
};

type AcceptMetaAction = IRequestAcceptMetaAction | ISuccessAcceptMetaAction | IFailureAcceptMetaAction;

//GET ALL - PROJECT
export interface IRequestGetProjectsAction {
  type: typeof Types.REQUEST_GET_PROJECTS;
  payload: {
    idCiclo: number;
    idCicloColaborador: number;
    idFuncionario?: number;
  };
};

export interface ISuccessGetProjectsAction {
  type: typeof Types.SUCCESS_GET_PROJECTS;
  payload: IProjectType[];
};

export interface IFailureGetProjectsAction {
  type: typeof Types.FAILURE_GET_PROJECTS;
  message: string;
};

type GetProjectsAction = IRequestGetProjectsAction | ISuccessGetProjectsAction | IFailureGetProjectsAction;

//GET BY ID - PROJECT
export interface IRequestGetProjectsByIdAction {
  type: typeof Types.REQUEST_GET_PROJECT_BY_ID;
  payload: {
    idCicloColaboradorProjeto: number;
    idFuncionario?: number;
    idCicloColaborador: number;
  };
};

export interface ISuccessGetProjectsByIdAction {
  type: typeof Types.SUCCESS_GET_PROJECT_BY_ID;
  payload: IProjectType;
};

export interface IFailureGetProjectsByIdAction {
  type: typeof Types.FAILURE_GET_PROJECT_BY_ID;
  message: string;
};

type GetProjectsByIdAction = IRequestGetProjectsByIdAction | ISuccessGetProjectsByIdAction | IFailureGetProjectsByIdAction;

//POST - PROJECT
export interface IRequestAddProjectAction {
  type: typeof Types.REQUEST_ADD_PROJECT;
  payload: {
    project: Partial<IProjectType>;
    idCicloColaborador: number;
  }
};

export interface ISuccessAddProjectAction {
  type: typeof Types.SUCCESS_ADD_PROJECT;
  payload: IProjectType;
};

export interface IFailureAddProjectAction {
  type: typeof Types.FAILURE_ADD_PROJECT;
  message: string;
};

type AddProjectAction = IRequestAddProjectAction | ISuccessAddProjectAction | IFailureAddProjectAction;

//EDIT - PROJECT
export interface IRequestEditProjectAction {
  type: typeof Types.REQUEST_EDIT_PROJECT;
  payload: {
    project: IProjectType;
    idCicloColaborador: number;
  }
};

export interface ISuccessEditProjectAction {
  type: typeof Types.SUCCESS_EDIT_PROJECT;
  payload: IProjectType;
};

export interface IFailureEditProjectAction {
  type: typeof Types.FAILURE_EDIT_PROJECT;
  message: string;
};

type EditProjectAction = IRequestEditProjectAction | ISuccessEditProjectAction | IFailureEditProjectAction;

//DELETE - PROJECT
export interface IRequestDelProjectAction {
  type: typeof Types.REQUEST_DEL_PROJECT;
  payload: {
    idCicloColaboradorProjeto: number;
    idFuncionario?: number;
    idCicloColaborador: number;
  }
};

export interface ISuccessDelProjectAction {
  type: typeof Types.SUCCESS_DEL_PROJECT;
  idCicloColaboradorProjeto: number;
};

export interface IFailureDelProjectAction {
  type: typeof Types.FAILURE_DEL_PROJECT;
  message: string;
};

type DelProjectAction = IRequestDelProjectAction | ISuccessDelProjectAction | IFailureDelProjectAction;

// APROVAÇÃO
export interface IRequestAprovacaoAction {
  type: typeof Types.REQUEST_APROVACAO;
  payload: {
    idCiclo: number;
    idCicloColaborador: number;
    idFuncionario?: number;
  }
};

export interface ISuccessAprovacaoAction {
  type: typeof Types.SUCCESS_APROVACAO;
};

export interface IFailureAprovacaoAction {
  type: typeof Types.FAILURE_APROVACAO;
  message: string;
};

type AprovacaoAction = IRequestAprovacaoAction | ISuccessAprovacaoAction | IFailureAprovacaoAction;



export type ProfileMetasActionTypes =
  ProfileLoadAction |
  ISetCurrentTabAction |
  GetProfileMetasAction |
  AcceptMetaAction |
  GetProjectsAction |
  GetProjectsByIdAction |
  AddProjectAction |
  EditProjectAction |
  DelProjectAction |
  AprovacaoAction;
